import { createApi } from '@reduxjs/toolkit/query/react';

import { ICreatePollFormValues, Poll } from 'constants/types';

import { API_URLS, REQUEST_METHOD } from '../constants/global';
import { baseQueryForumFormData } from './baseQuery';

export const pollManagement = createApi({
  reducerPath: 'pollApi',
  baseQuery: baseQueryForumFormData,
  endpoints: (builder) => ({
    addPoll: builder.mutation<void, ICreatePollFormValues>({
      query: (newPoll) => ({
        url: API_URLS.POLL,
        method: REQUEST_METHOD.POST,
        body: newPoll,
      }),
    }),

    getPollResults: builder.query<any, string>({
      query: (pollId) => ({
        url: `${API_URLS.POLL}/${pollId}`,
        method: REQUEST_METHOD.GET,
      }),
    }),

    stopPoll: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `${API_URLS.STOP_POLL}/${id}`,
        method: REQUEST_METHOD.PUT,
      }),
    }),
  }),
});

export const {
  useAddPollMutation,
  useGetPollResultsQuery,
  useStopPollMutation,
} = pollManagement;
